export const BUTTON_VARIANTS = {
    CONTAINED: "contained",
    OUTLINED: "outlined",
    OUTLINED_GRAY: "outlined_gray",
    CONTAINED_GRAY:"contained_gray",
    TEXT: "text"
}